import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { FindReplaceTool } from "../components/FindReplaceTool";
import { FrBreadcrumb } from "../components/FrBreadcrumb";
import { FrExplainer } from "../components/FrExplainer";

export function FindReplacePage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <FrBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.fr_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.fr_intro()}
          </p>
        </header>

        <FindReplaceTool />

        <FrExplainer
          howTo={m.fr_howto()}
          faqs={[
            { q: m.fr_faq1_q(), a: m.fr_faq1_a() },
            { q: m.fr_faq2_q(), a: m.fr_faq2_a() },
            { q: m.fr_faq3_q(), a: m.fr_faq3_a() },
            { q: m.fr_faq4_q(), a: m.fr_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
